import { Box, MenuItem, Typography, styled, useMediaQuery } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import BarChart from '../../component/charts/BarChart'
import HorizontalChart from '../../component/charts/HorizontalChart'
import FilterSelect from '../../component/select/filterSelect'
import { LIMIT_ALL } from '../../constants/pagination'
import InputDatePicker from '../../component/input/inputDatePicker'
import moment, { Moment } from 'moment'
import InputTextField from '../../component/input/inputTextField'
import { debouncedApiCall, filterActiveOptions } from '../../utils/app.utils'
import TableRowCommon from '../../component/table/TableRowCommon'
import TableCustom from '../../component/table/tableCustom'
import { ProjectApi, getProject } from '../../api/project/project.api';
import RangeCustom from '../../component/ranges/RangeCustom'
import { useTranslation } from 'react-i18next'
import { FiscalYearApi } from '../../api/fiscal-year/fiscalyear.api'
import { DashboardApi } from '../../api/dashboard/dashboard.api'
import AutocompleteSelect from '../../component/select/autoCompleteSelect'
// import { TypesApi } from '../../api/type/type.api'

type Props = {}

const ContainerBox = styled('main')({
    width: '100%',
    height: "100%",
})
type budgetDashboardType = {
    departmentName: string[];
    sumAllBudget: any[];
    sumAllPaid: any[];
}

const HomePublic: React.FC = ({ }: Props) => {
    const { t } = useTranslation();

    const matches = useMediaQuery('(min-width:600px)');

    const [startDate, setStateDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [keyword, setKeyword] = useState<string>("");
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(Number);


    const [id_department, set_id_department] = useState<number>(0);
    const [departmentData, setDepartmentData] = useState<any[]>([]);

    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC")

    const [data, setData] = useState<any[]>([])

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const [budgetSourceData, setBudgetSourceData] = useState<any>({
        labels: [],
        datasets: [
            {
                label: '',
                data: [],
                backgroundColor: ['#90BE6D', '#F94144', '#5084bc', '#afbc50', '#bc8850'],
                hoverOffset: 4,
            }
        ],
    })
    const [budgetSourceDepartment, setBudgetSourceDepartment] = useState<budgetDashboardType>({
        sumAllBudget: [],
        sumAllPaid: [],
        departmentName: []
    })

    const [trackPlanOption, setTrackPlanOption] = useState<any[]>([]);

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        debouncedApiCall({ searchItem: e.target.value, setItem: setKeyword })
    }


    const headCells = [
        {
            id: "RANK", disablePadding: false, width: 120, align: 'center', label: "ลำดับ"
        },
        {
            id: "projectName", disablePadding: false, align: "center", sortable: true, width: 600, label: "โครงการ"
        },
        {
            id: "sumAllBudget", disablePadding: false, align: "center", sortable: true, width: 205, label: "งบประมาณ"

        },
        {
            id: "sumAllPaid", disablePadding: false, width: 205, sortable: true, align: "center", label: "งบเบิกจ่าย"

        },
        {
            id: "WORK_PERIOD", disablePadding: false, width: 200, align: "center", label: "งวดงาน"

        },
        {
            id: "DATE", disablePadding: false, align: "center", width: 300, label: "ระยะเวลาโครงการ"

        },
        {
            id: "AGENCY", disablePadding: false, align: "center", width: 240, label: "หน่วยงาน"

        },
        {
            id: "idFiscalYear", disablePadding: false, align: "center", width: 140, label: "ปีงบประมาณ"
        },
        {
            id: "STATUS", class: true, disablePadding: true, width: matches ? 330 : 150, align: "center", label: "สถานะ"

        },
    ];

    const renderData = (objData: any, index: any) => {
        index = page * pageLimit - pageLimit + index + 1
        const { projectName, idProject, sumAllPaid, departmentName, periodCount, projectStartDate, projectEndDate, statusPercent, statusName, sumAllBudget, idFiscalYear } =
            objData;
        const diffInDays = moment(projectEndDate).diff(projectStartDate, 'days');
        const diffInMonths = moment(projectEndDate).diff(projectStartDate, 'months') % 12;
        const diffInYears = moment(projectEndDate).diff(projectStartDate, 'years');

        let diffString;
        if (diffInYears > 0) {
            diffString = `${diffInYears} ปี${diffInYears > 1 ? '' : ''}`;
            if (diffInMonths > 0) {
                diffString += ` ${diffInMonths} เดือน${diffInMonths > 1 ? '' : ''}`;
            }
        } else if (diffInMonths > 0) {
            diffString = `${diffInMonths} เดือน${diffInMonths > 1 ? '' : ''}`;
        } else {
            diffString = `${diffInDays} วัน${diffInDays > 1 ? '' : ''}`;
        }

        const today: Moment = moment(new Date());
        const todayToEndDate = moment(projectEndDate).diff(today, 'days')
        const percentDate = (todayToEndDate / diffInDays) * 100;


        function handlePercentCheck(percent: number): string {
            // วันที่ปัจจุบัน เกินวันที่สิ้นสุด
            if (todayToEndDate < 0 && percent === 100 || todayToEndDate < 0 && percent === null) {
                return '#98d44c'
            } else if (todayToEndDate < 0 && percent < 100) {
                return '#ff0404'
            } else if (todayToEndDate > 0 && percent === 100) {
                return '#98d44c'
            } else if (todayToEndDate > 0 && percentDate > 25 && percent < 100) {
                return '#a0c4e4'
            } else if (todayToEndDate > 0 && percentDate <= 25 && percent < 100) {
                return '#fffc04'
            }
            return '#1976d2'
        }
        let colorPercentCount: string = handlePercentCheck(statusPercent);


        const objRenderData = {
            key: index,
            id: idProject,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: index },
                {
                    option: "TEXT",
                    align: "left",
                    label: projectName || "-",
                },
                {
                    option: "PRICE",
                    align: "right",
                    label: sumAllBudget || 0,
                },
                {
                    option: "PRICE",
                    align: "right",
                    label: sumAllPaid || 0,
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: `${periodCount} งวด` || "-"
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: `${moment(projectStartDate).format("DD/MM/YYYY")} - ${moment(projectEndDate).format("DD/MM/YYYY")}  (${diffString})` || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: departmentName || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: idFiscalYear || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: true,
                    component: (
                        <div className='w-full flex flex-col md:flex-row gap-y-3 gap-x-4'>
                            <span className='text-base_secondary flex items-start flex-col mt-4 w-full'>
                                <RangeCustom color={colorPercentCount} num={Number(statusPercent || 10)} />
                                <span>
                                    <Typography variant='subtitle1'>
                                        {<li className='list-item leading-[desired-line-height] text-base_disable'>
                                            {statusName || "-"}
                                        </li>}
                                    </Typography>
                                </span>
                            </span>
                        </div >
                    ),
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const [idFiscalYearChart, setIdFiscalYearChart] = useState<number>(moment().add(543, 'year').year());
    const [fiscalYear, setFiscalYear] = useState<any[]>([]);
    const [projectStatus, setProjectStatus] = useState<any[]>([]);
    const [types, setTypes] = useState<any[]>([]);
    const [idType, setIdType] = useState<number>(0);
    const [idStatus, setIdStatus] = useState<number>(Number);
    const [idFiscalYear, setIdFiscalYear] = useState<number>(Number);

    const handleGetData = useCallback(async () => {
        try {
            let condition: getProject = {
                page: page,
                limit: pageLimit
            }
            if (startDate) condition = { ...condition, startDate: startDate }
            if (endDate) condition = { ...condition, endDate: endDate }
            if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
            if (idStatus) condition = { ...condition, idStatus: idStatus }
            if (keyword) condition = { ...condition, keyword: keyword }
            if (sortType) condition = { ...condition, sortType: sortType }
            if (sortBy) condition = { ...condition, sortBy: sortBy }
            if (idType) condition = { ...condition, idType: idType }
            if (id_department) condition = { ...condition, idDepartment: id_department }
            await ProjectApi.publicData(condition)
                .then(res => {
                    if (res.status === 200) {
                        // console.log(res.data?.result?.items)
                        setData(res.data?.result?.items)
                        setTotalPage(res.data?.result?.meta?.totalItems)
                    }
                })
                .catch(error => {
                    throw new Error("Can't fetch data", error)
                })
        } catch (error) {
            console.log(error)
        }
    }, [page, pageLimit, idFiscalYear, idStatus, startDate, endDate, sortType, sortBy, keyword, idType, id_department])

    const handleGetProjectStatus = async () => {
        await ProjectApi.publicAllProjectStatus()
            .then(res => {
                if (res.status === 200) {
                    setProjectStatus(res.data?.result)
                }
            })
            .catch(error => {
                throw new Error("Can't fetch data", error)
            })
    }
    const handleGetFiscalYear = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    setFiscalYear(res.data?.result?.items)
                }
            })
            .catch(error => {
                throw new Error("Can't fetch data", error)
            })
    }

    // DASHBOARD
    const handleGetBudgetSourceDashboard = useCallback(async () => {
        await DashboardApi.getBudgetSourcePublic(idFiscalYearChart)
            .then(res => {
                if (res.status === 200) {
                    const color = ['#90BE6D', '#F94144', '#5084bc', '#afbc50', '#bc8850'];
                    const data = res.data?.result?.map((list: any) => Number(...list?.sumBudget));
                    const optionLabel = res.data?.result?.map((list: any) => list?.budgetName);
                    const data_api = res.data?.result?.map((x: any, index: number) => {
                        return {
                            name: x?.budgetName,
                            y: +x?.sumBudget || 0,
                            color: color[index],
                        }
                    })
                    if (data && optionLabel && data_api?.length > 0) {
                        setBudgetSourceData((prev: any) => ({
                            ...prev,
                            labels: [...optionLabel],
                            data_api: data_api,
                            datasets: prev?.datasets?.map((list: any) => ({
                                ...list,
                                data: [...data]
                            }))
                        }))
                    } else {
                        setBudgetSourceData({
                            labels: [],
                            datasets: [
                                {
                                    label: '',
                                    data: [],
                                    backgroundColor: ['#90BE6D', '#F94144', '#5084bc', '#afbc50', '#bc8850'],
                                    hoverOffset: 4,
                                }
                            ],
                        })
                    }
                }
            })
            .catch(error => {
                throw new Error("Can't fetch data or Some thing wrong", error)
                // console.log(error)
            })
    }, [idFiscalYearChart])
    const handleGetBudgetDepartmentDashboard = useCallback(async () => {
        await DashboardApi.getBudgetDepartmentPublic(idFiscalYearChart)
            .then(res => {
                if (res.status === 200) {
                    const departmentName = res.data?.result?.map((list: any) => list?.departmentName) || [];
                    const sunAllBudget = res.data?.result?.map((list: any) => Number(list?.sumAllBudget)) || [];
                    const sunAllPaid = res.data?.result?.map((list: any) => Number(list?.sumAllPaid)) || [];
                    setBudgetSourceDepartment((prev) => ({
                        ...prev,
                        departmentName: departmentName,
                        sumAllBudget: sunAllBudget,
                        sumAllPaid: sunAllPaid
                    }));
                }
            })
            .catch(error => {
                throw new Error("Can't fetch data", error)
            })
    }, [idFiscalYearChart])

    const handleGetType = useCallback(async () => {
        await ProjectApi.publicProjectType(idFiscalYear)
            .then(res => {
                if (res.status === 200) {
                    setTypes(res.data?.result || []);
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idFiscalYear])
    const handleGetDepartment = async () => {
        await ProjectApi.publicDepartmentData().then((res) => {
            if (res.status < 300) {
                console.log(res.data)
                const data: any[] = res.data?.result || [];
                if (data.length > 0) {
                    setDepartmentData(data)
                } else {
                    setDepartmentData([]);
                }
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        handleGetType()
    }, [idFiscalYear])
    useEffect(() => {
        handleGetProjectStatus();
        handleGetFiscalYear();
        handleGetDepartment();
        handleGetBudgetDepartmentDashboard();
    }, [])

    useEffect(() => {
        handleGetBudgetSourceDashboard();
    }, [handleGetBudgetSourceDashboard])

    useEffect(() => {
        handleGetBudgetDepartmentDashboard();
    }, [handleGetBudgetDepartmentDashboard])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    const BoxShadow = styled(Box)({
        boxShadow: "0px 0px 1px 1px rgba(0,0,0,0.1)"
    })

    return (
        <div className='container w-screen h-auto max-h-full m-auto py-10 px-4 md:py-[5rem] md:px-[50px]'>
            <ContainerBox>
                <Box className='my-4'>
                    <Typography variant='h4' className='text-primary'>{"สถิติข้อมูล"}</Typography>
                </Box>
                <div style={{
                    boxShadow: "0px 0px 1px 1px rgba(0,0,0,0.1)"
                }} className='w-full mt-4 overflow-hidden p-2 h-full rounded-xl'>
                    <section className='w-full flex flex-col justify-start gap-2'>
                        <span className='w-full max-w-[300px]'>
                            <AutocompleteSelect
                                isFilter
                                disableClearable
                                headingNormal
                                heading={"ปีงบประมาณ"}
                                labelId="label-fiscal-year-chart"
                                options={filterActiveOptions(fiscalYear, 'fiscalYearStatus', 'idFiscalYear', [idFiscalYearChart])}
                                getOptionLabel={(option: any) => String(option?.fiscalYear ?? '')}
                                getOptionDisabled={(option: any) => option?.fiscalYearStatus === t("STATUS.INACTIVE")}
                                isOptionEqualToValue={(option: any, value: any) => option?.idFiscalYear === value?.idFiscalYear}
                                value={fiscalYear?.find((list: any) => list?.idFiscalYear === idFiscalYearChart) || null}
                                onChange={(_, value: any) => {
                                    value && setIdFiscalYearChart(Number(value?.idFiscalYear))
                                }}
                            />
                        </span>
                    </section>
                    <section className='grid grid-cols-12 gap-3 mt-4'>
                        <article className='col-span-12 md:col-span-4 lg:col-span-4'>
                            <span className='w-full'>
                                <BarChart
                                    valueSuffix=' บาท'
                                    enabled_line
                                    data={budgetSourceData}
                                    option={trackPlanOption}
                                    className='h-full'
                                    maxWidth='341px'
                                    heading='แยกตามงบประมาณ' />
                            </span>
                        </article>
                        <article className='col-span-12 md:col-span-8 lg:col-span-8'>
                            <span className='w-full'>
                                <HorizontalChart
                                    sumAllBudget={budgetSourceDepartment.sumAllBudget || []}
                                    sumAllPaid={budgetSourceDepartment.sumAllPaid || []}
                                    categories={budgetSourceDepartment.departmentName || []}
                                    heading='แยกตามหน่วยงาน'
                                    className='h-full'
                                />
                            </span>
                        </article>
                    </section>
                </div>

                <Box mt={4} mb={2}>
                    <Typography variant='h4' className='text-primary'>{"ติดตามสถานะโครงการ"}</Typography>
                </Box>
                <div style={{
                      boxShadow: "0px 0px 1px 1px rgba(0,0,0,0.1)"
                }} className='w-full p-2 rounded-xl'>
                    <section className='grid grid-cols-12 gap-3'>
                        <span className='col-span-12 md:col-span-6 lg:col-span-3'>
                            <AutocompleteSelect
                                isFilter
                                headingNormal
                                heading={"ปีงบประมาณ"}
                                labelId="label-fiscal-year"
                                placeholder="ทั้งหมด"
                                options={filterActiveOptions(fiscalYear, 'fiscalYearStatus', 'idFiscalYear', [idFiscalYear])}
                                getOptionLabel={(option: any) => String(option?.fiscalYear ?? '')}
                                getOptionDisabled={(option: any) => option?.fiscalYearStatus === t("STATUS.INACTIVE")}
                                isOptionEqualToValue={(option: any, value: any) => option?.idFiscalYear === value?.idFiscalYear}
                                value={fiscalYear?.find((list: any) => list?.idFiscalYear === idFiscalYear) || null}
                                onChange={(_, value: any) => {
                                    setIdFiscalYear(Number(value?.idFiscalYear || 0))
                                    setIdType(0);
                                }}
                            />
                        </span>
                        <span className='col-span-12 md:col-span-6 lg:col-span-3'>
                            <FilterSelect
                                headingNormal
                                heading={"หน่วยงาน"}
                                renderValue={() => id_department === 0 ? "ทั้งหมด" : departmentData?.find((list: any) => list?.idDepartment === id_department)?.departmentName}
                                label={'STATUS.LABEL'}
                                selectId="select-fiscal-year"
                                value={id_department}
                                labelId="label-fiscal-year"
                                onchange={(event) => {
                                    const value = event.target.value
                                    value && set_id_department(Number(value))
                                }}
                                options={[
                                    <MenuItem onClick={() => set_id_department(0)} value={0}>{"ทั้งหมด"}</MenuItem>,
                                    departmentData && departmentData?.map((list: any) => (
                                        <MenuItem
                                            // disabled={list?.fiscalYearStatus === t("STATUS.INACTIVE")}
                                            key={list?.idDepartment}
                                            value={list?.idDepartment}>
                                            {list?.departmentName || ""}
                                        </MenuItem>
                                    ))]}
                            />
                        </span>
                        <span className='col-span-12 md:col-span-6 lg:col-span-3'>
                            <InputDatePicker
                                disableEndDate={endDate}
                                headingNormal
                                heading='ตั้งแต่วันที่'
                                onChange={(e) => setStateDate(moment(e).format("YYYY-MM-DD"))}
                                onClear={() => setStateDate("")}
                                value={startDate}
                                allowClear />
                        </span>
                        <span className='col-span-12 md:col-span-6 lg:col-span-3'>
                            <InputDatePicker
                                headingNormal
                                disableStartDate={startDate}
                                disabled={startDate === ""}
                                heading='ถึงวันที่'
                                onChange={(e) => setEndDate(moment(e).format("YYYY-MM-DD"))}
                                onClear={() => setEndDate("")}
                                value={endDate}
                                allowClear />
                        </span>
                        <span className='col-span-12 md:col-span-6 lg:col-span-4'>
                            <FilterSelect
                                headingNormal
                                heading={t("ประเภทโครงการ")}
                                renderValue={() => idType === 0 ? "ทั้งหมด" : types?.find((list: any) => list?.idType === idType)?.typeName}
                                label={t('STATUS.LABEL')}
                                disabled={!idFiscalYear}
                                selectId="select-project-type"
                                value={idType}
                                labelId="label-project-type"
                                onchange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    const value = event.target.value
                                    value ? setIdType(+value) : setIdType(0);
                                }}
                                options={[
                                    <MenuItem value={0}>ทั้งหมด</MenuItem>,
                                    types && types.map((list: any) => (
                                        <MenuItem key={list?.idType} value={list?.idType} >
                                            {list?.typeName}
                                        </MenuItem>
                                    ))
                                ]}
                            />
                        </span>
                        <span className='col-span-12 md:col-span-6 lg:col-span-4'>
                            <AutocompleteSelect
                                headingNormal
                                heading={"สถานะโครงการ"}
                                value={projectStatus?.find((list: any) => list?.idStatus === idStatus) || null}
                                labelId="label-typeOfMissionGroup"
                                onChange={(_, value) => {
                                    // console.log(value?.idStatus)
                                    setIdStatus(value?.idStatus)
                                }}
                                placeholder='ทั้งหมด'
                                getOptionLabel={(option) => option?.projectStatusName || ''}
                                options={projectStatus || []}
                            />
                        </span>
                        <span className='col-span-12 lg:col-span-4'>
                            <InputTextField
                                onchange={handleSearch}
                                headingNormal
                                placeholder='ค้นหา'
                                heading='ค้นหา'
                            />
                        </span>
                    </section>
                    <section className='mt-4'>
                        <TableCustom
                            tableFixedWidth
                            tableMinWidth={1440}
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalPage}
                            rowsData={data && data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </div>
            </ContainerBox>
        </div>
    )
}

export default HomePublic